import React from 'react';
import { useNavigate } from 'react-router-dom';

const Home = () => {
  const navigate = useNavigate();

  const ourServices = [
    "Photocopying and high-quality document printing",
    "Binding (dissertations, reports)",
    "Document lamination",
    "Large format printing (posters)",
    "ID card printing",
    "Scanning services",
    "Custom T-shirts, mugs, and merchandise",
    "Resume and cover letter printing",
    "Research paper formatting",
    "Flyers, brochures, and invitation printing"
  ];
    
  return (
    <div className='w-full bg-gray-300 pb-10'>
      <div className='w-11/12 m-auto bg-gray-200 pb-10 rounded-sm shadow-sm'>
        <header className="w-full h-1/2 flex border border-b-gray-500">
          {/* <img
            src={require('../assets/images/hands-holding-printed-papers-over-a-printer.jpg')}
            className="w-1/2 h-full object-cover"
            alt="Hands holding printed papers over a printer"
            loading="lazy"
          />
          <div className="w-1 bg-black"></div> */}
          {/* <img
            src={require('../assets/images/photo-printing-document.webp')}
            className="w-1/2 h-full object-cover"
            alt="Photo printing document"
            loading="lazy"
          /> */}
          <img
            src={require('../assets/images/printer-office-setting-ready-days-work.jpg')}
            className="w-full h-1/2 object-cover"
            alt="Printer office setting ready days work"
            loading="lazy"
          />
        </header>
        <div className='w-[95%] m-auto mt-5'>
          <section>
            <h1 className="text-3xl font-bold text-left p-4">
              Online Printing Service
            </h1>
            <p className="text-lg text-left p-4 indent-2">
              We offer a variety of printing services tailored to the needs of students and professionals. Whether it's large format printing, binding your thesis, or custom merchandise, we have you covered.
            </p>
          </section>
          <section className="bg-gray-100 rounded-md p-4 my-5 ">
            <h1 className="text-3xl font-bold text-left text-white bg-black rounded-md p-4 inline-block">
              Our Services
            </h1>
            <ul className="list-disc list-inside pt-3 pl-5 my-2 text-lg">
              {ourServices.map(service => (
                <li className='hover:text-blue-400'>{service}</li>
              ))}
            </ul>
          </section>
          <section>
            <button
                className="bg-green-600 text-white text-2xl px-4 py-2 rounded-md hover:bg-blue-600"
                onClick={() => navigate('/print')}
            >
                Order Now
            </button>
            </section>
        </div>
      </div>
    </div>
  );
};

export default Home;
